import ConfirmationEmailSender from "../../login/ui/send-confirmation-email"

export default function Page(props) {
  return <ConfirmationEmailSender {...props} />
}